import React from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { scrollBody, card, VerifiedBadge, SectionTitle, WebEntryLayout } from './entryHelpers';
import { patientAuthFlow } from '../../auth/patientAuthFlow';

export default function PatRegNHCIDScreen() {
  const navigate = useNavigate();
  const { nhcId, neoVerifyId } = patientAuthFlow.getState();

  return (
    <WebEntryLayout>
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: T.white, fontFamily: T.font }}>
      {/* Progress Header - step 8/8, 100% success */}
      <div style={{ padding: '12px 16px', background: T.white, borderBottom: `1px solid ${T.border}` }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: T.text, fontFamily: T.font }}>NeoHealthCard ID Generated</div>
        <div style={{ fontSize: 9, color: T.textSec, fontFamily: T.font }}>Step 8 of 8</div>
        <div style={{ height: 3, borderRadius: 2, background: T.border, marginTop: 6 }}>
          <div style={{ width: '100%', height: '100%', borderRadius: 2, background: T.success }} />
        </div>
      </div>

      <div style={scrollBody}>
        {/* Success Block */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 16,
              background: `${T.success}1F`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <svg width={28} height={28} viewBox="0 0 24 24" fill="none" stroke={T.success} strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          </div>
          <div style={{ fontSize: 16, fontWeight: 800, color: T.text, textAlign: 'center' }}>Your NeoHealthCard ID is Ready</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: T.navy, fontFamily: T.mono, letterSpacing: '0.06em' }}>{nhcId || '—'}</div>
          <div style={{ fontSize: 10, color: T.textSec, fontFamily: T.mono }}>{neoVerifyId || ''}</div>
          <VerifiedBadge text="VERIFIED PATIENT" color={T.success} />
        </div>

        {/* Verification Status */}
        <div style={card()}>
          <SectionTitle text="Verification Status" />

          {/* Row 1 */}
          <div style={{ padding: '8px 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 2 }}>
              <span style={{ fontSize: 11, fontWeight: 600, color: T.text }}>Patient Identity</span>
              <VerifiedBadge text="VERIFIED PATIENT" color={T.success} />
            </div>
            <div style={{ fontSize: 9, color: T.textSec }}>Verified by OTP/KYC</div>
          </div>

          {/* Row 2 */}
          <div style={{ padding: '8px 0', borderTop: `1px solid ${T.borderLight}` }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 2 }}>
              <span style={{ fontSize: 11, fontWeight: 600, color: T.text }}>Self-uploaded records</span>
              <VerifiedBadge text="PATIENT UPLOADED" color={T.warning} />
            </div>
            <div style={{ fontSize: 9, color: T.textSec }}>Marked as patient-uploaded until verified</div>
          </div>

          {/* Row 3 */}
          <div style={{ padding: '8px 0', borderTop: `1px solid ${T.borderLight}` }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 2 }}>
              <span style={{ fontSize: 11, fontWeight: 600, color: T.text }}>Provider-issued records</span>
              <VerifiedBadge text="VERIFIED" color={T.success} />
            </div>
            <div style={{ fontSize: 9, color: T.textSec }}>Signed by verified doctor/lab/hospital/pharmacy</div>
          </div>
        </div>

        {/* Info Box */}
        <div
          style={{
            background: `${T.navy}0A`,
            border: `1px solid ${T.navy}1A`,
            borderRadius: 10,
            padding: 12,
            fontSize: 9,
            lineHeight: 1.6,
            color: T.textSec,
          }}
        >
          Doctors verify clinical documents, not your existence. Your NeoHealthCard ID proves your identity through OTP/KYC. Records you upload are marked as patient-uploaded until a verified provider signs them.
        </div>

        {/* Continue Button */}
        <button
          onClick={() => navigate('/patient/register/card')}
          style={{
            width: '100%',
            padding: '14px 0',
            background: `linear-gradient(135deg, ${T.teal}, ${T.overlap})`,
            color: T.white,
            border: 'none',
            borderRadius: 14,
            fontSize: 14,
            fontWeight: 700,
            fontFamily: T.font,
            cursor: 'pointer',
            marginTop: 6,
          }}
        >
          Continue
        </button>
      </div>
    </div>
    </WebEntryLayout>
  );
}
